import { Interpolation } from '@emotion/styled';
import { Theme } from '@mui/material';

export const globalStyle: Interpolation<Theme> = (theme: Theme) => ({
  html: {
    backgroundColor: theme.palette.background.default,
  },
  body: {
    margin: 0,
  },
  ul: {
    paddingLeft: 0
  }
});
